import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Form,
  Table,
  Row,
  Col,
  Button,
  Card,
  Alert,
  Dropdown,
  DropdownButton,
  Modal,
  Tab,
  Tabs,
  OverlayTrigger,
  Tooltip,
  Spinner,
} from 'react-bootstrap';
import { FaBars, FaArrowRight, FaAngleDown, FaArrowLeft } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { mutate } from 'swr';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import { Menu, Item, useContextMenu } from 'react-contexify';
import {
  updateProntuarioById,
  insertProntuarioById,
} from '../../redux/features/prontuario/prontuarioSlice';
import AtestadoMedico from '../atestado/AtestadoMedico';
import RequisicaoMedica from '../requisicao/RequisicaoMedica';
import history from '../../services/history';
import api from '../../services/api';
import { anamnese } from '../../helpers/prontuario/anamnese';
import { medicamentos as dbmedicamentos } from '../../helpers/prontuario/medicamentos';
import { cid } from '../../helpers/prontuario/cid';
import styles from '../../styles.module.css';
import PacienteInfo from '../../components/paciente/PacienteInfo';
import ReceituarioMedico from '../receita/ReceituarioMedico';
import generateProntuarioPDF from './generateProntuarioPDF';
import generateCongTXTPDF from '../laudo/eco/generateCongTXTPDF';
import selectEcoById from '../../services/ecodoppler';
import useTipoExame from '../../hooks/useTipoExame';
import useExamesLaboratoriais from './exames-laboratoriais/useExamesLaboratoriais';
import ExamesLaboratoriaisModal from './exames-laboratoriais/ExamesLaboratoriaisModal';
import ArquivosProntuarioModal, {
  ACCEPT_ARQUIVO_PRONTUARIO,
} from './ArquivosProntuarioModal';
import FileUploadModal from '../../components/agenda/Modals/FileUploadModal';

const PROCEDIMENTOS_CONSULTA = [1, 58, 800];

const queixasSorted = anamnese.queixas.sort((a, b) =>
  a.sintoma.localeCompare(b.sintoma)
);
const cidValueLabelSorted = cid
  .map(i => ({ value: i.value, label: `${i.label} - ${i.value}` }))
  .sort((a, b) => a.value.localeCompare(b.value));
const habitosSorted = anamnese.habitos.sort((a, b) =>
  a.sintoma.localeCompare(b.sintoma)
);
const isdaSorted = anamnese.isda.sort((a, b) =>
  a.sintoma.localeCompare(b.sintoma)
);
const pessoaisSorted = anamnese.pessoais.sort((a, b) =>
  a.sintoma.localeCompare(b.sintoma)
);
const hipotesesSorted = anamnese.hipoteses.sort((a, b) =>
  a.sintoma.localeCompare(b.sintoma)
);
const condutasSorted = anamnese.condutas.sort((a, b) =>
  a.sintoma.localeCompare(b.sintoma)
);

// TODO: TESTAR antes de refatorar com react testing library p/ garantir que tudo continua funcionando! (tipo DepositFormV2 no lv)
// TODO: passos pra ver onde precisa otimizar: Profiler (react dev tools) -> network -> aba performance
// React Dev tools + Lighthouse (auditoria) + Web Vitals (métricas UX) + Bundle Analyzer
// TODO: colocar id/outros dados do prontuário na url e eliminar todos os modais de laudo
export default function FormProntuario() {
  const dispatch = useDispatch();
  const medico = useSelector(state => state.doctor.profile);
  const { prontuario } = useSelector(state => state.prontuario);
  const { tipoexame } = useTipoExame();
  const examesLaboratoriais = useExamesLaboratoriais({ tipoexame });
  const { funcionario } = useSelector(state => state.funcionario);
  const { show } = useContextMenu();
  const atual = prontuario?.atual ? prontuario.atual : undefined;
  const anterior = prontuario?.anterior ? prontuario.anterior : undefined;
  const anteriores = prontuario?.anteriores ? prontuario.anteriores : undefined;
  const [inputDisabled, setInputDisabled] = useState(true);
  const [isSavingProntuario, setIsSavingProntuario] = useState(false);
  const [isGeneratingTelefone, setIsGeneratingTelefone] = useState(false);
  const [localLoadingAtividades, setLocalLoadingAtividades] = useState(false); // cada um desses localLoading devem ir pro seu componente
  const [atividades, setAtividades] = useState([]);
  const [showConsulta, setShowConsulta] = useState(false);
  const [showMedicamento, setShowMedicamento] = useState(false);
  const [showConsultaTelefone, setShowConsultaTelefone] = useState(false);
  const [showGravaParcial, setShowGravaParcial] = useState(false);
  const [showGravaTotal, setShowGravaTotal] = useState(false);
  const [showReceita, setShowReceita] = useState(false);
  const [showAtestado, setShowAtestado] = useState(false);
  const [showRequisicao, setShowRequisicao] = useState(false);
  const [dataLabor, setDataLabor] = useState(
    new Date().toISOString().split('T')[0]
  );
  const [activeKey, setActiveKey] = useState('prontuario');
  const [alert, setAlert] = useState({ variant: '', mensagem: '' });
  const [fieldValues, setFieldValues] = useState({
    codconsulta: anteriores[0]?.CODCONSULTA || '',
    queixas: anteriores[0]?.QUEIXAS || '',
    familiares: anteriores[0]?.ANTECEDENTES_FLIA || '',
    pessoais: anteriores[0]?.ANTECEDENTES_PESSOAIS || '',
    conduta: anteriores[0]?.CONDUTA || '',
    complementares: anteriores[0]?.EXAMES_COMPLEMENTARES || '',
    fisico: anteriores[0]?.EXAME_FISICO || '',
    habitos: anteriores[0]?.HABITOS || '',
    hipotese: anteriores[0]?.HIPOTESE_DIAGNOSTICA || '',
    isda: anteriores[0]?.ISDA || '',
    medicamentos: anteriores[0]?.MEDICAMENTOS || '',
    obs: anteriores[0]?.OBS || '',
    observacao: anteriores[0]?.OBSERVACOES || '',
    peso: anteriores[0]?.PESOPAC || '',
    cid: anteriores[0]?.CID || '',
    cid2: anteriores[0]?.CID2 || '',
    cid3: anteriores[0]?.CID3 || '',
    gravado: anteriores[0]?.GRAVADO || '',
    tipo: anteriores[0]?.TIPO || '',
    dataFormatada: anteriores[0]?.dataFormatada || '',
    idadePAC: anteriores[0]?.idadePAC || '',
    convenio: anteriores[0]?.SIGLACONV || '',
    procedimento: anteriores[0]?.DESCPROCEDI || '',
    realizou: anteriores[0]?.REALIZOU || '',
  });
  const [assinaturaDigital, setAssinaturaDigital] = useState(false);
  const [codArquivos, setCodArquivos] = useState(null);
  const [showUploadArquivos, setShowUploadArquivos] = useState(false);
  const isFuncionario = !!funcionario;
  const consultaAberta = [atual, anterior, ...(anteriores || [])].find(
    item => item && String(item.CODCONSULTA) === String(fieldValues.codconsulta)
  );
  const codProcediInformado = Number(
    consultaAberta?.CODPROCEDI ?? fieldValues.codProcedi
  );
  const codProcediArquivo = PROCEDIMENTOS_CONSULTA.includes(codProcediInformado)
    ? codProcediInformado
    : 1;

  const handleVerArquivos = codLaudo => {
    setCodArquivos(codLaudo);
  };

  const handleFecharArquivos = () => {
    setCodArquivos(null);
  };

  const handleFecharAtestado = useCallback(() => {
    setShowAtestado(false);
  }, []);
  const handleFecharRequisicao = useCallback(() => {
    setShowRequisicao(false);
  }, []);

  useEffect(() => {
    handleEvolucao(atual);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const getDropDownMenu = (consulta, variant) => {
    const isSelected =
      String(consulta.CODCONSULTA) === String(fieldValues.codconsulta);

    return (
      <DropdownButton
        variant={variant}
        active={isSelected}
        drop="right"
        title={consulta.dataFormatada}
        onClick={() => handleEvolucao(consulta)}
        aria-current={isSelected ? 'true' : undefined}
      >
        <Dropdown.Item
          disabled={isFuncionario}
          onClick={event => handlePrincipal(consulta, event)}
        >
          Consulta Principal
        </Dropdown.Item>
        <Dropdown.Item
          disabled={isFuncionario}
          onClick={event => handleComplementar(consulta, event)}
        >
          Consulta Complementar
        </Dropdown.Item>
        <Dropdown.Item
          disabled={isFuncionario}
          onClick={event => handleTelefone(event)}
        >
          Consulta Telefone
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={() => setShowReceita(true)}>
          Receituário Médico
        </Dropdown.Item>
        <Dropdown.Item onClick={() => setShowAtestado(true)}>
          Atestado Médico
        </Dropdown.Item>
        <Dropdown.Item onClick={() => setShowRequisicao(true)}>
          Requisição de Exames
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item as="div" className="px-3 py-2">
          <Form.Control
            type="date"
            size="sm"
            value={dataLabor}
            disabled={isFuncionario}
            onChange={e => setDataLabor(e.target.value)}
          />
          <Button
            variant="outline-secondary"
            size="sm"
            className="mt-2 w-100"
            disabled={isFuncionario}
            onClick={() =>
              examesLaboratoriais.handleNovosExamesLaboratoriais(
                consulta,
                dataLabor
              )
            }
          >
            Novos Exames Laboratoriais
          </Button>
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item
          disabled={isFuncionario}
          onClick={() =>
            examesLaboratoriais.handleListarExamesLaboratoriais(consulta)
          }
        >
          Listar Exames Laboratoriais
        </Dropdown.Item>
      </DropdownButton>
    );
  };

  const renderTreeMedicamento = nodes => (
    <TreeItem key={nodes.id} itemId={nodes.id} label={nodes.name}>
      {Array.isArray(nodes.children) &&
        nodes.children.map(node => renderTreeMedicamento(node))}
    </TreeItem>
  );

  const handleSelectMedicamento = (event, nodeId, elmID) => {
    dbmedicamentos.children.forEach(classe => {
      classe.children.forEach(e => {
        if (e.id === nodeId) {
          setFieldValues({
            ...fieldValues,
            medicamentos: (fieldValues.medicamentos ?? '') + '  ' + e.name, // changing the state of *changed value*
          });
          document.getElementById(elmID).focus();
          event.stopPropagation();
        }
      });
    });
  };

  const handleMenu = (event, id) => {
    event.preventDefault();
    show(event, { id });
  };

  const handleMenuClick = ({ event }, elmID) => {
    switch (elmID) {
      case 'editQueixas':
        setFieldValues({
          ...fieldValues,
          queixas: (fieldValues.queixas ?? '') + '  ' + event.currentTarget.id,
        });
        event.stopPropagation();
        break;
      case 'editHabitos':
        setFieldValues({
          ...fieldValues,
          habitos: (fieldValues.habitos ?? '') + '  ' + event.currentTarget.id,
        });
        event.stopPropagation();
        break;
      case 'editISDA':
        setFieldValues({
          ...fieldValues,
          isda: (fieldValues.isda ?? '') + '  ' + event.currentTarget.id,
        });
        event.stopPropagation();
        break;
      case 'editPessoais':
        setFieldValues({
          ...fieldValues,
          pessoais:
            (fieldValues.pessoais ?? '') + '  ' + event.currentTarget.id,
        });
        event.stopPropagation();
        break;
      case 'editFamiliares':
        setFieldValues({
          ...fieldValues,
          familiares:
            (fieldValues.familiares ?? '') + '  ' + event.currentTarget.id,
        });
        event.stopPropagation();
        break;
      case 'editFisico':
        setFieldValues({
          ...fieldValues,
          fisico: (fieldValues.fisico ?? '') + '  ' + event.currentTarget.id,
        });
        event.stopPropagation();
        break;
      case 'editConduta':
        setFieldValues({
          ...fieldValues,
          conduta: (fieldValues.conduta ?? '') + '  ' + event.currentTarget.id,
        });
        event.stopPropagation();
        break;
      case 'editHipotese':
        setFieldValues({
          ...fieldValues,
          hipotese:
            (fieldValues.hipotese ?? '') + '  ' + event.currentTarget.id,
        });
        event.stopPropagation();
        break;
      case 'editMedicamentos':
        setShowMedicamento(true);
        document.getElementById(elmID).focus();
        break;
      default:
    }
  };

  async function handleAtividades(consulta) {
    try {
      setLocalLoadingAtividades(true);
      const result = await api.get(`pacientes/${consulta.CODPAC}/atividades`);
      setAtividades(result.data);
    } catch (error) {
      toast.error(
        error?.response?.data?.error || 'Erro ao carregar atividades!'
      );
    } finally {
      setLocalLoadingAtividades(false);
    }
  }

  function handleEcg(atividade) {
    history.push(`/formEcg/${atividade.CODLAUDO}`);
  }

  const handleStress = atividade => {
    history.push(`/reportStress/${atividade.CODLAUDO}`);
  };

  async function handleEco(atividade) {
    // TODO: nao tem como saber o tipo de eco sem chamar o selectEcoById?
    const eco = await selectEcoById(atividade.CODLAUDO);
    if (eco?.TIPOECO === 'EcoC') {
      if (eco.CODREALIZOU === 4860) {
        await generateCongTXTPDF(eco, 'imprimirNormal', 1);
      } else {
        history.push(`/reportEcoCongenito/${atividade.CODLAUDO}`);
      }
    } else {
      history.push(`/reportDoppler/${atividade.CODLAUDO}`);
    }
  }

  const handleEvolucao = consulta => {
    const textareaElem = document.getElementsByClassName('textAreaDestaque');
    let i = 0;
    const temConsultaPrincipal = prontuario?.anteriores?.some(
      item =>
        item?.TIPO?.trim() === 'PCP' &&
        String(item.CODCONSULTA) !== String(consulta?.CODCONSULTA)
    );
    const isPrimeiraConsulta =
      !temConsultaPrincipal || (prontuario?.anteriores?.length || 0) <= 1;
    const gravadoTrim = consulta?.GRAVADO?.trim() || '';
    const tipoExistente = consulta?.TIPO?.trim() || '';
    const tipoEfetivo =
      tipoExistente ||
      (isPrimeiraConsulta && gravadoTrim !== 'SIM' ? 'PCP' : '');

    setFieldValues({
      ...fieldValues,
      codconsulta: consulta?.CODCONSULTA || '',
      queixas: consulta?.QUEIXAS || '',
      familiares: consulta?.ANTECEDENTES_FLIA || '',
      pessoais: consulta?.ANTECEDENTES_PESSOAIS || '',
      conduta: consulta?.CONDUTA || '',
      complementares: consulta?.EXAMES_COMPLEMENTARES || '',
      fisico: consulta?.EXAME_FISICO || '',
      habitos: consulta?.HABITOS || '',
      hipotese: consulta?.HIPOTESE_DIAGNOSTICA || '',
      isda: consulta?.ISDA || '',
      medicamentos: consulta?.MEDICAMENTOS || '',
      obs: consulta?.OBS || '',
      observacao: consulta?.OBSERVACOES || '',
      peso: consulta?.PESOPAC || '',
      cid: consulta?.CID || '',
      cid2: consulta?.CID2 || '',
      cid3: consulta?.CID3 || '',
      gravado: consulta?.GRAVADO || '',
      tipo: tipoEfetivo,
      dataFormatada: consulta?.dataFormatada || '',
      idadePAC: consulta?.idadePAC || '',
      convenio: consulta?.SIGLACONV || '',
      procedimento: consulta?.DESCPROCEDI || '',
      realizou: consulta?.REALIZOU || '',
    });
    if (tipoEfetivo === 'PCP' && gravadoTrim === 'SIM') {
      for (i = 0; i < textareaElem.length; i++) {
        textareaElem[i].style.backgroundColor = '';
      }
      setShowConsulta(true);
      setAlert({
        variant: 'primary',
        mensagem: 'Consulta Principal já Gravada!',
      });
      setInputDisabled(true);
    } else if (tipoEfetivo === 'SEC' && gravadoTrim === 'SIM') {
      for (i = 0; i < textareaElem.length; i++) {
        textareaElem[i].style.backgroundColor = '#bdf294';
      }
      setShowConsulta(true);
      setAlert({
        variant: 'primary',
        mensagem: 'Consulta Complementar já Gravada!',
      });
      setInputDisabled(true);
    } else if (tipoEfetivo === 'SEC' && gravadoTrim === 'NAO') {
      for (i = 0; i < textareaElem.length; i++) {
        textareaElem[i].style.backgroundColor = '#bdf294';
      }
      setShowConsulta(true);
      setAlert({
        variant: 'primary',
        mensagem: 'Consulta Complementar não foi Gravada ainda!',
      });
      setInputDisabled(false);
    } else if (tipoEfetivo === 'PCP' && gravadoTrim === 'PAR') {
      for (i = 0; i < textareaElem.length; i++) {
        textareaElem[i].style.backgroundColor = '';
      }
      setShowConsulta(true);
      setAlert({
        variant: 'primary',
        mensagem: 'Consulta Principal Gravada Parcialmente!',
      });
      setInputDisabled(false);
    } else if (tipoEfetivo === 'PCP' && gravadoTrim !== 'SIM') {
      for (i = 0; i < textareaElem.length; i++) {
        textareaElem[i].style.backgroundColor = '';
      }
      setShowConsulta(true);
      setAlert({
        variant: 'primary',
        mensagem:
          'Digite a Consulta Principal do Paciente ' +
          (consulta?.NOMEPAC || atual?.NOMEPAC || ''),
      });
      setInputDisabled(false);
    } else if (tipoEfetivo === 'SEC' && gravadoTrim === 'PAR') {
      for (i = 0; i < textareaElem.length; i++) {
        textareaElem[i].style.backgroundColor = '#bdf294';
      }
      setShowConsulta(true);
      setAlert({
        variant: 'primary',
        mensagem: 'Consulta Complementar Gravada Parcialmente!',
      });
      setInputDisabled(false);
    } else if (!tipoEfetivo && gravadoTrim !== 'SIM') {
      for (i = 0; i < textareaElem.length; i++) {
        textareaElem[i].style.backgroundColor = '';
      }
      setShowConsulta(true);
      setAlert({
        variant: 'warning',
        mensagem: 'Consulta ou Retorno - tipo não definido!',
      });
      setInputDisabled(false);
    }
  };

  const handlePrincipal = (consulta, event) => {
    event.stopPropagation();
    const result = prontuario?.anteriores?.filter(
      principal =>
        principal?.TIPO?.trim() === 'PCP' &&
        (String(principal.CODCONSULTA) !== String(consulta?.CODCONSULTA) ||
          principal?.GRAVADO?.trim() === 'SIM')
    );
    if (result?.length > 0) {
      setInputDisabled(true);
      setShowConsulta(true);
      setAlert({
        variant: 'danger',
        mensagem:
          'Consulta Principal já existe! Data: ' + result[0].dataFormatada,
      });
    } else {
      setInputDisabled(false);
      setShowConsulta(true);
      setAlert({
        variant: 'primary',
        mensagem: 'Digite a Consulta Principal do Paciente ' + consulta.NOMEPAC,
      });
      const textareaElem = document.getElementsByClassName('textAreaDestaque');
      for (let i = 0; i < textareaElem.length; i++) {
        textareaElem[i].style.backgroundColor = '';
      }
      setFieldValues({
        codconsulta: consulta?.CODCONSULTA || '',
        queixas: consulta?.QUEIXAS || '',
        familiares: consulta?.ANTECEDENTES_FLIA || '',
        pessoais: consulta?.ANTECEDENTES_PESSOAIS || '',
        conduta: consulta?.CONDUTA || '',
        complementares: consulta?.EXAMES_COMPLEMENTARES || '',
        fisico: consulta?.EXAME_FISICO || '',
        habitos: consulta?.HABITOS || '',
        hipotese: consulta?.HIPOTESE_DIAGNOSTICA || '',
        isda: consulta?.ISDA || '',
        medicamentos: consulta?.MEDICAMENTOS || '',
        obs: consulta?.OBS || '',
        observacao: consulta?.OBSERVACOES || '',
        peso: consulta?.PESOPAC || '',
        cid: consulta?.CID || '',
        cid2: consulta?.CID2 || '',
        cid3: consulta?.CID3 || '',
        gravado: consulta?.GRAVADO || '',
        tipo: 'PCP',
        dataFormatada: consulta?.dataFormatada || '',
        idadePAC: consulta?.idadePAC || '',
        convenio: consulta?.SIGLACONV || '',
        procedimento: consulta?.DESCPROCEDI || '',
        realizou: consulta?.REALIZOU || '',
      });
    }
  };

  const handleComplementar = (consulta, event) => {
    event.stopPropagation();
    if (consulta.TIPO?.trim() === 'PCP' && consulta.GRAVADO?.trim() === 'SIM') {
      setInputDisabled(true);
      setShowConsulta(true);
      setAlert({
        variant: 'primary',
        mensagem: 'Consulta Principal já Gravada!',
      });
      setFieldValues({
        codconsulta: consulta?.CODCONSULTA || '',
        queixas: consulta?.QUEIXAS || '',
        familiares: consulta?.ANTECEDENTES_FLIA || '',
        pessoais: consulta?.ANTECEDENTES_PESSOAIS || '',
        conduta: consulta?.CONDUTA || '',
        complementares: consulta?.EXAMES_COMPLEMENTARES || '',
        fisico: consulta?.EXAME_FISICO || '',
        habitos: consulta?.HABITOS || '',
        hipotese: consulta?.HIPOTESE_DIAGNOSTICA || '',
        isda: consulta?.ISDA || '',
        medicamentos: consulta?.MEDICAMENTOS || '',
        obs: consulta?.OBS || '',
        observacao: consulta?.OBSERVACOES || '',
        peso: consulta?.PESOPAC || '',
        cid: consulta?.CID || '',
        cid2: consulta?.CID2 || '',
        cid3: consulta?.CID3 || '',
        gravado: consulta?.GRAVADO || '',
        tipo: 'PCP',
        dataFormatada: consulta?.dataFormatada || '',
        idadePAC: consulta?.idadePAC || '',
        convenio: consulta?.SIGLACONV || '',
        procedimento: consulta?.DESCPROCEDI || '',
        realizou: consulta?.REALIZOU || '',
      });
    } else if (
      consulta.TIPO?.trim() === 'SEC' &&
      consulta.GRAVADO?.trim() === 'SIM'
    ) {
      setInputDisabled(true);
      setShowConsulta(true);
      setAlert({
        variant: 'danger',
        mensagem: 'Consulta Complementar já Gravada!',
      });
      setFieldValues({
        codconsulta: consulta?.CODCONSULTA || '',
        queixas: consulta?.QUEIXAS || '',
        familiares: consulta?.ANTECEDENTES_FLIA || '',
        pessoais: consulta?.ANTECEDENTES_PESSOAIS || '',
        conduta: consulta?.CONDUTA || '',
        complementares: consulta?.EXAMES_COMPLEMENTARES || '',
        fisico: consulta?.EXAME_FISICO || '',
        habitos: consulta?.HABITOS || '',
        hipotese: consulta?.HIPOTESE_DIAGNOSTICA || '',
        isda: consulta?.ISDA || '',
        medicamentos: consulta?.MEDICAMENTOS || '',
        obs: consulta?.OBS || '',
        observacao: consulta?.OBSERVACOES || '',
        peso: consulta?.PESOPAC || '',
        cid: consulta?.CID || '',
        cid2: consulta?.CID2 || '',
        cid3: consulta?.CID3 || '',
        gravado: consulta?.GRAVADO || '',
        tipo: 'PCP',
        dataFormatada: consulta?.dataFormatada || '',
        idadePAC: consulta?.idadePAC || '',
        convenio: consulta?.SIGLACONV || '',
        procedimento: consulta?.DESCPROCEDI || '',
        realizou: consulta?.REALIZOU || '',
      });
    } else {
      let textareaElements = document.getElementsByClassName(
        'textAreaDestaque'
      );
      for (let i = 0; i < textareaElements.length; i++) {
        textareaElements[i].style.backgroundColor = '#bdf294';
      }
      setInputDisabled(false);
      setShowConsulta(true);
      setAlert({
        variant: 'success',
        mensagem:
          'Registrar Evolução da Consulta Anterior Datada de ' +
          anterior?.dataFormatada,
      });
      setFieldValues({
        ...fieldValues,
        codconsulta: consulta?.CODCONSULTA || '',
        queixas: anterior?.QUEIXAS || '',
        familiares: anterior?.ANTECEDENTES_FLIA || '',
        pessoais: anterior?.ANTECEDENTES_PESSOAIS || '',
        conduta: anterior?.CONDUTA || '',
        complementares: anterior?.EXAMES_COMPLEMENTARES || '',
        fisico: anterior?.EXAME_FISICO || '',
        habitos: anterior?.HABITOS || '',
        hipotese: anterior?.HIPOTESE_DIAGNOSTICA || '',
        isda: anterior?.ISDA || '',
        medicamentos: anterior?.MEDICAMENTOS || '',
        obs: anterior?.OBS || '',
        observacao: anterior?.OBSERVACOES || '',
        peso: anterior?.PESOPAC || '',
        cid: anterior?.CID || '',
        cid2: anterior?.CID2 || '',
        cid3: anterior?.CID3 || '',
        gravado: '',
        tipo: 'SEC',
        dataFormatada: consulta?.dataFormatada || '',
        idadePAC: consulta?.idadePAC || '',
        convenio: consulta?.SIGLACONV || '',
        procedimento: consulta?.DESCPROCEDI || '',
        realizou: consulta?.REALIZOU || '',
      });
    }
    setShowConsulta(true);
  };

  const handleTelefone = event => {
    event.stopPropagation();
    setFieldValues({
      ...fieldValues,
      codMedico: medico ? medico?.codMed : anterior?.CODREALIZOU,
      codProcedi: 800,
      codConv: anterior?.CODCONV ?? atual?.CODCONV ?? null,
      codPac: anterior?.CODPAC ?? atual?.CODPAC ?? null,
      codEncaminhou: anterior?.CODENCAMINHOU ?? atual?.CODENCAMINHOU ?? null,
      codRealizou: medico ? medico?.codMed : anterior?.CODREALIZOU,
      codFaturamento: anterior?.CODFATURAMENTO || '',
      queixas: anterior?.QUEIXAS || '',
      familiares: anterior?.ANTECEDENTES_FLIA || '',
      pessoais: anterior?.ANTECEDENTES_PESSOAIS || '',
      conduta: anterior?.CONDUTA || '',
      complementares: anterior?.EXAMES_COMPLEMENTARES || '',
      fisico: anterior?.EXAME_FISICO || '',
      habitos: anterior?.HABITOS || '',
      hipotese: anterior?.HIPOTESE_DIAGNOSTICA || '',
      isda: anterior?.ISDA || '',
      medicamentos: anterior?.MEDICAMENTOS || '',
      obs: anterior?.OBS || '',
      observacao: anterior?.OBSERVACOES || '',
      peso: anterior?.PESOPAC || '',
      cid: anterior?.CID || '',
      cid2: anterior?.CID2 || '',
      cid3: anterior?.CID3 || '',
      gravado: '',
      tipo: 'SEC',
      dataFormatada: atual?.dataFormatada || '',
      idadePAC: atual?.idadePAC || '',
      convenio: atual?.SIGLACONV || '',
      procedimento: atual?.DESCPROCEDI || '',
      realizou: atual?.REALIZOU || '',
    });
    setInputDisabled(false);
    setShowConsultaTelefone(true);
  };

  const handleGerarConsultaTelefone = async event => {
    event.preventDefault();
    setIsGeneratingTelefone(true);
    setShowConsulta(true);
    setAlert({
      variant: 'success',
      mensagem:
        'Registrar Evolução (Telefone) da Consulta Anterior Datada de ' +
        anterior?.dataFormatada,
    });

    dispatch(insertProntuarioById(fieldValues))
      .then(result => {
        if (!result) return;

        setFieldValues({
          ...fieldValues,
          codconsulta: result?.atual?.CODCONSULTA,
          codMedico: medico ? medico?.codMed : result?.atual?.CODREALIZOU,
          codProcedi: result?.atual?.CODPROCEDI,
          codConv: result?.atual?.CODCONV,
          codPac: result?.atual?.CODPAC,
          codEncaminhou: result?.atual?.CODENCAMINHOU,
          codRealizou: medico?.codMed,
          codFaturamento: result?.atual?.CODFATURAMENTO || '',
          queixas: result?.atual?.QUEIXAS || '',
          familiares: result?.atual?.ANTECEDENTES_FLIA || '',
          pessoais: result?.atual?.ANTECEDENTES_PESSOAIS || '',
          conduta: result?.atual?.CONDUTA || '',
          complementares: result?.atual?.EXAMES_COMPLEMENTARES || '',
          fisico: result?.atual?.EXAME_FISICO || '',
          habitos: result?.atual?.HABITOS || '',
          hipotese: result?.atual?.HIPOTESE_DIAGNOSTICA || '',
          isda: result?.atual?.ISDA || '',
          medicamentos: result?.atual?.MEDICAMENTOS || '',
          obs: result?.atual?.OBS || '',
          observacao: result?.atual?.OBSERVACOES || '',
          peso: result?.atual?.PESOPAC || '',
          cid: result?.atual?.CID || '',
          cid2: result?.atual?.CID2 || '',
          cid3: result?.atual?.CID3 || '',
          gravado: result?.atual?.GRAVADO || '',
          tipo: result?.atual?.TIPO || '',
          dataFormatada: result?.atual?.dataFormatada || '',
          idadePAC: result?.atual?.idadePAC || '',
          convenio: result?.atual?.SIGLACONV || '',
          procedimento: result?.atual?.DESCPROCEDI || '',
          realizou: result?.atual?.REALIZOU || '',
        });
        setShowConsultaTelefone(false);
        if (prontuario) {
          setAlert({ variant: 'success', mensagem: result?.message });
        } else {
          setAlert({
            variant: 'danger',
            mensagem: 'Falha ao Inserir Consulta Telefone!',
          });
        }
        const elemQueixas = document.getElementById('editQueixas');
        if (elemQueixas) elemQueixas.focus();
      })
      .finally(() => setIsGeneratingTelefone(false));
  };

  const handleGravarProntuario = async event => {
    if (!fieldValues?.codconsulta) {
      toast.warn('Erro de validação: consulta não identificada.');
      return;
    }

    try {
      event.preventDefault();
      setIsSavingProntuario(true);
      const gravadoDefinitivo = fieldValues.gravado.trim() === 'SIM';
      const result = await dispatch(updateProntuarioById(fieldValues)); // nao vai ter dispatch na V2
      if (!result) return;

      if (gravadoDefinitivo && atual?.CODPAC) {
        try {
          const resposta = await api.put('/agenda/atendido', {
            CODPAC: atual.CODPAC,
          });
          if (resposta?.data?.message === 'Nenhum agendamento encontrado.') {
            toast.warn(
              'Nenhum horário em atendimento para marcar como Atendido.'
            );
          } else {
            await mutate(key => Array.isArray(key) && key[0] === 'agendas');
          }
        } catch (error) {
          toast.warn(
            error?.response?.data?.error ||
            'Prontuário gravado, mas a agenda não foi atualizada.'
          );
        }
      }
      toast.success('Prontuário gravado!');
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Erro ao gravar prontuário!');
    } finally {
      setIsSavingProntuario(false);
    }
  };

  const handleGravarProntuarioParcial = () => {
    if (!fieldValues?.codconsulta) return;
    const payload =
      fieldValues.gravado?.trim() === 'SIM'
        ? fieldValues
        : {
          ...fieldValues,
          gravado: 'PAR',
          tipo: fieldValues.tipo || 'PCP',
        };
    if (fieldValues.gravado?.trim() !== 'SIM') {
      setFieldValues(payload);
    }
    dispatch(updateProntuarioById(payload));
  };

  const handleChange = e => {
    e.preventDefault();
    setFieldValues({ ...fieldValues, [e.target.name]: e.target.value });
  };

  return (
    <>
      <Tabs
        defaultActiveKey="prontuario"
        activeKey={activeKey}
        onSelect={key => setActiveKey(key)}
        fill
      >
        {/* https://legacy.reactjs.org/docs/code-splitting.html: Avoiding fallbacks. lazy e suspense nessas tabs */}
        <Tab eventKey="prontuario" title="Prontuário">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <Button size="sm" onClick={() => history.goBack()}>
                <FaArrowLeft />
              </Button>
              <h5 className="m-0">PRONTUÁRIO ELETRÔNICO</h5>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col sm={2}>
                  <Card.Header className="text-center">CONSULTAS</Card.Header>
                  <Table responsive="sm" bordered size="sm">
                    <tbody>
                      {prontuario?.anteriores?.map(consulta => {
                        const isSelected =
                          String(consulta.CODCONSULTA) ===
                          String(fieldValues.codconsulta);

                        return (
                          <tr
                            key={consulta.CODCONSULTA}
                            className={
                              isSelected
                                ? 'table-active text-center'
                                : 'text-center'
                            }
                          >
                            <td>
                              {consulta?.TIPO?.trim() === 'SEC'
                                ? getDropDownMenu(consulta, 'outline-danger')
                                : consulta?.TIPO?.trim() === 'PCP'
                                  ? getDropDownMenu(consulta, 'outline-primary')
                                  : getDropDownMenu(consulta, 'outline-success')}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </Col>
                <Col sm={10}>
                  <Form noValidate>
                    <strong className="mr-auto">Nome do Paciente: </strong>
                    {`${atual?.CODPAC} - ${atual?.NOMEPAC}`}
                    <br></br>
                    <strong className="mr-auto">Data de Nasc: </strong>
                    {`${atual?.dataNasc}`}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong className="mr-auto">Idade: </strong>
                    {`${fieldValues?.idadePAC}  anos`}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <br></br>
                    <strong className="mr-auto">Convênio: </strong>
                    {fieldValues?.convenio}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong className="mr-auto">Procedimento: </strong>
                    {fieldValues?.procedimento}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <br></br>
                    <strong className="mr-auto">Código do Prontuário: </strong>
                    {fieldValues?.codconsulta}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong className="mr-auto">Data do Prontuário: </strong>
                    <strong style={{ color: 'blue', fontWeight: 'bold' }}>
                      {fieldValues?.dataFormatada}{' '}
                    </strong>
                    <br></br>
                    <strong className="mr-auto">Médico que Realizou: </strong>
                    {`${fieldValues?.realizou}`}
                    <hr></hr>
                    <Alert show={showConsultaTelefone} variant="warning">
                      <Alert.Heading>Gerar consulta telefone?</Alert.Heading>
                      <Button
                        onClick={e => handleGerarConsultaTelefone(e)}
                        variant="warning"
                        disabled={isGeneratingTelefone}
                      >
                        {isGeneratingTelefone ? (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />{' '}
                            Gerando...
                          </>
                        ) : (
                          'Confirmar'
                        )}
                      </Button>
                    </Alert>
                    {showConsulta && (
                      <Alert
                        variant={alert.variant}
                        style={{ textAlign: 'right' }}
                      >
                        {alert.mensagem}
                      </Alert>
                    )}
                    <Form.Row className="row-cols-1">
                      <Form.Group size="sm" controlId="editQueixas">
                        <Form.Label className="d-flex justify-content-between">
                          <strong>Queixa Principal e História</strong>
                          <OverlayTrigger overlay={<Tooltip>Queixas</Tooltip>}>
                            <span className="d-inline-block">
                              <Button
                                size="sm"
                                onClick={e => handleMenu(e, 'idQueixa')}
                              >
                                <FaBars style={{ width: 18, height: 18 }} />
                              </Button>
                            </span>
                          </OverlayTrigger>
                        </Form.Label>
                        <p>
                          <Form.Control
                            disabled={inputDisabled || isFuncionario}
                            as="textarea"
                            rows={
                              fieldValues.queixas?.split('\n').length + 3 || 5
                            }
                            name="queixas"
                            className="textAreaDestaque"
                            value={
                              isFuncionario
                                ? '********** ACESSO RESTRITO **********'
                                : fieldValues.queixas || ''
                            }
                            onBlur={() => {
                              if (!isFuncionario) {
                                handleGravarProntuarioParcial();
                              }
                            }}
                            onChange={isFuncionario ? undefined : handleChange}
                          />
                        </p>
                        <Menu className={styles.styleMenu} id={'idQueixa'}>
                          {queixasSorted.map(queixa => (
                            <Item
                              selected
                              key={queixa.sintoma}
                              id={queixa.sintoma}
                              onClick={e => handleMenuClick(e, 'editQueixas')}
                            >
                              {queixa.sintoma}
                            </Item>
                          ))}
                        </Menu>
                      </Form.Group>
                      <Form.Group size="sm" controlId="editMedicamentos">
                        <Form.Label className="d-flex justify-content-between">
                          <strong>Medicações em Uso</strong>{' '}
                          <OverlayTrigger
                            overlay={<Tooltip>Lista de Medicações</Tooltip>}
                          >
                            <span className="d-inline-block">
                              <Button
                                size="sm"
                                variant="info"
                                onClick={e =>
                                  handleMenuClick(e, 'editMedicamentos')
                                }
                              >
                                Medicamentos
                              </Button>{' '}
                              {showMedicamento && (
                                <Button
                                  size="sm"
                                  variant="outline-danger"
                                  onClick={() => setShowMedicamento(false)}
                                >
                                  Fechar
                                </Button>
                              )}
                            </span>
                          </OverlayTrigger>
                        </Form.Label>
                        <Form.Control
                          disabled={inputDisabled}
                          as="textarea"
                          rows={
                            fieldValues.medicamentos?.split('\n').length + 1 ||
                            3
                          }
                          name="medicamentos"
                          value={fieldValues.medicamentos || ''}
                          onBlur={() => {
                            if (!isFuncionario) {
                              handleGravarProntuarioParcial();
                            }
                          }}
                          onChange={isFuncionario ? undefined : handleChange}
                        />
                      </Form.Group>
                      {showMedicamento && (
                        <SimpleTreeView
                          aria-label="rich object"
                          defaultExpanded={['root']}
                          slots={{
                            expandIcon: FaArrowRight,
                            collapseIcon: FaAngleDown,
                          }}
                          onSelectedItemsChange={(e, nodeId) =>
                            handleSelectMedicamento(
                              e,
                              nodeId,
                              'editMedicamentos'
                            )
                          }
                        >
                          {renderTreeMedicamento(dbmedicamentos)}
                        </SimpleTreeView>
                      )}
                      <Form.Group size="sm" controlId="editHabitos">
                        <Form.Label className="d-flex justify-content-between">
                          <strong>Hábitos</strong>
                          <OverlayTrigger overlay={<Tooltip>Hábitos</Tooltip>}>
                            <span className="d-inline-block">
                              <Button
                                size="sm"
                                onClick={e => handleMenu(e, 'idHabitos')}
                              >
                                <FaBars style={{ width: 18, height: 18 }} />
                              </Button>
                            </span>
                          </OverlayTrigger>
                        </Form.Label>
                        <Form.Control
                          disabled={inputDisabled}
                          as="textarea"
                          rows={
                            fieldValues.habitos?.split('\n').length + 1 || 3
                          }
                          name="habitos"
                          value={
                            isFuncionario
                              ? '********** ACESSO RESTRITO **********'
                              : fieldValues.habitos || ''
                          }
                          onBlur={() => {
                            if (!isFuncionario) {
                              handleGravarProntuarioParcial();
                            }
                          }}
                          onChange={isFuncionario ? undefined : handleChange}
                        />
                        <Menu className={styles.styleMenu} id={'idHabitos'}>
                          {habitosSorted.map(habito => (
                            <Item
                              selected
                              key={habito.sintoma}
                              id={habito.sintoma}
                              onClick={e => handleMenuClick(e, 'editHabitos')}
                            >
                              {habito.sintoma}
                            </Item>
                          ))}
                        </Menu>
                      </Form.Group>
                      <Form.Group size="sm" controlId="editISDA">
                        <Form.Label className="d-flex justify-content-between">
                          <strong>ISDA</strong>
                          <OverlayTrigger overlay={<Tooltip>ISDA</Tooltip>}>
                            <span className="d-inline-block">
                              <Button
                                size="sm"
                                onClick={e => handleMenu(e, 'idISDA')}
                              >
                                <FaBars style={{ width: 18, height: 18 }} />
                              </Button>
                            </span>
                          </OverlayTrigger>
                        </Form.Label>
                        <div>
                          <p>
                            <Form.Control
                              disabled={inputDisabled}
                              as="textarea"
                              rows={
                                fieldValues.isda?.split('\n').length + 1 || 3
                              }
                              name="isda"
                              value={
                                isFuncionario
                                  ? '********** ACESSO RESTRITO **********'
                                  : fieldValues.isda || ''
                              }
                              onBlur={() => {
                                if (!isFuncionario) {
                                  handleGravarProntuarioParcial();
                                }
                              }}
                              onChange={
                                isFuncionario ? undefined : handleChange
                              }
                            />
                          </p>
                          <Menu className={styles.styleMenu} id="idISDA">
                            {isdaSorted.map(isda => (
                              <Item
                                key={isda.sintoma}
                                id={isda.sintoma}
                                onClick={e => handleMenuClick(e, 'editISDA')}
                              >
                                {isda.sintoma}
                              </Item>
                            ))}
                          </Menu>
                        </div>
                      </Form.Group>
                      <Form.Group size="sm" controlId="editPessoais">
                        <Form.Label className="d-flex justify-content-between">
                          <strong>Antecedentes Pessoais</strong>
                          <OverlayTrigger
                            overlay={<Tooltip>Antecedentes Pessoais</Tooltip>}
                          >
                            <span className="d-inline-block">
                              <Button
                                size="sm"
                                onClick={e => handleMenu(e, 'idPessoais')}
                              >
                                <FaBars style={{ width: 18, height: 18 }} />
                              </Button>
                            </span>
                          </OverlayTrigger>
                        </Form.Label>
                        <div>
                          <p>
                            <Form.Control
                              disabled={inputDisabled}
                              as="textarea"
                              rows={
                                fieldValues.pessoais?.split('\n').length + 1 ||
                                3
                              }
                              name="pessoais"
                              value={
                                isFuncionario
                                  ? '********** ACESSO RESTRITO **********'
                                  : fieldValues.pessoais || ''
                              }
                              onBlur={() => {
                                if (!isFuncionario) {
                                  handleGravarProntuarioParcial();
                                }
                              }}
                              onChange={
                                isFuncionario ? undefined : handleChange
                              }
                            />
                          </p>
                          <Menu className={styles.styleMenu} id="idPessoais">
                            {pessoaisSorted.map(pessoal => (
                              <Item
                                key={pessoal.sintoma}
                                id={pessoal.sintoma}
                                onClick={e =>
                                  handleMenuClick(e, 'editPessoais')
                                }
                              >
                                {pessoal.sintoma}
                              </Item>
                            ))}
                          </Menu>
                        </div>
                      </Form.Group>
                      <Form.Group size="sm" controlId="editFamiliares">
                        <Form.Label className="d-flex justify-content-between">
                          <strong>Antecedentes Familiares</strong>
                          <OverlayTrigger
                            overlay={<Tooltip>Antecedentes Familiares</Tooltip>}
                          >
                            <span className="d-inline-block">
                              <Button
                                size="sm"
                                onClick={e => handleMenu(e, 'idFamiliares')}
                              >
                                <FaBars style={{ width: 18, height: 18 }} />
                              </Button>
                            </span>
                          </OverlayTrigger>
                        </Form.Label>
                        <div>
                          <p>
                            <Form.Control
                              disabled={inputDisabled}
                              as="textarea"
                              rows={
                                fieldValues.familiares?.split('\n').length +
                                1 || 3
                              }
                              name="familiares"
                              value={
                                isFuncionario
                                  ? '********** ACESSO RESTRITO **********'
                                  : fieldValues.familiares || ''
                              }
                              onBlur={() => {
                                if (!isFuncionario) {
                                  handleGravarProntuarioParcial();
                                }
                              }}
                              onChange={
                                isFuncionario ? undefined : handleChange
                              }
                            />
                          </p>
                          <Menu
                            className={styles.styleMenu}
                            id={'idFamiliares'}
                          >
                            {anamnese.familiares.map(familiar => (
                              <Item
                                key={familiar.sintoma}
                                id={familiar.sintoma}
                                onClick={e =>
                                  handleMenuClick(e, 'editFamiliares')
                                }
                              >
                                {familiar.sintoma}
                              </Item>
                            ))}
                          </Menu>
                        </div>
                      </Form.Group>
                      <Form.Group size="sm" controlId="editComplementares">
                        <Form.Label className="d-flex justify-content-between">
                          <strong>Exames Complementares</strong>
                          <OverlayTrigger
                            overlay={<Tooltip>Exames Realizados</Tooltip>}
                          >
                            <span className="d-inline-block">
                              <Button
                                size="sm"
                                variant="info"
                                onClick={() => {
                                  setActiveKey('atv');
                                  handleAtividades(prontuario.atual);
                                }}
                              >
                                Atividades
                              </Button>
                            </span>
                          </OverlayTrigger>{' '}
                        </Form.Label>
                        <Form.Control
                          disabled={inputDisabled}
                          as="textarea"
                          rows={
                            fieldValues.complementares?.split('\n').length +
                            1 || 3
                          }
                          name="complementares"
                          value={
                            isFuncionario
                              ? '********** ACESSO RESTRITO **********'
                              : fieldValues.complementares || ''
                          }
                          onBlur={() => {
                            if (!isFuncionario) {
                              handleGravarProntuarioParcial();
                            }
                          }}
                          onChange={isFuncionario ? undefined : handleChange}
                        />
                      </Form.Group>
                      <Form.Group size="sm" controlId="editFisico">
                        <Form.Label className="d-flex justify-content-between">
                          <strong>Exame Físico</strong>
                          <OverlayTrigger
                            overlay={<Tooltip>Exame Físico</Tooltip>}
                          >
                            <span className="d-inline-block">
                              <Button
                                size="sm"
                                onClick={e => handleMenu(e, 'idFisico')}
                              >
                                <FaBars style={{ width: 18, height: 18 }} />
                              </Button>
                            </span>
                          </OverlayTrigger>
                        </Form.Label>
                        <div>
                          <p>
                            <Form.Control
                              disabled={inputDisabled}
                              as="textarea"
                              rows={
                                fieldValues.fisico?.split('\n').length + 1 || 3
                              }
                              name="fisico"
                              className="textAreaDestaque"
                              value={
                                isFuncionario
                                  ? '********** ACESSO RESTRITO **********'
                                  : fieldValues.fisico || ''
                              }
                              onBlur={() => {
                                if (!isFuncionario) {
                                  handleGravarProntuarioParcial();
                                }
                              }}
                              onChange={
                                isFuncionario ? undefined : handleChange
                              }
                            />
                          </p>
                          <Menu className={styles.styleMenu} id={'idFisico'}>
                            {anamnese.fisico.map(fisico => (
                              <Item
                                key={fisico.sintoma}
                                id={fisico.sintoma}
                                onClick={e => handleMenuClick(e, 'editFisico')}
                              >
                                {fisico.sintoma.substring(0, 50)}
                              </Item>
                            ))}
                          </Menu>
                        </div>
                      </Form.Group>
                      <Form.Group size="sm" controlId="editHipotese">
                        <Form.Label className="d-flex justify-content-between">
                          <strong>Hipótese Diagnóstica</strong>
                          <OverlayTrigger
                            overlay={<Tooltip>Hipótese Diagnóstica</Tooltip>}
                          >
                            <span className="d-inline-block">
                              <Button
                                size="sm"
                                onClick={e => handleMenu(e, 'idHipotese')}
                              >
                                <FaBars style={{ width: 18, height: 18 }} />
                              </Button>
                            </span>
                          </OverlayTrigger>
                        </Form.Label>
                        <div>
                          <p>
                            <Form.Control
                              disabled={inputDisabled}
                              as="textarea"
                              rows={
                                fieldValues.hipotese?.split('\n').length + 1 ||
                                3
                              }
                              name="hipotese"
                              value={
                                isFuncionario
                                  ? '********** ACESSO RESTRITO **********'
                                  : fieldValues.hipotese || ''
                              }
                              onBlur={() => {
                                if (!isFuncionario) {
                                  handleGravarProntuarioParcial();
                                }
                              }}
                              onChange={
                                isFuncionario ? undefined : handleChange
                              }
                            />
                          </p>
                          <Menu className={styles.styleMenu} id="idHipotese">
                            {hipotesesSorted.map(hipotese => (
                              <Item
                                key={hipotese.sintoma}
                                id={hipotese.sintoma}
                                onClick={e =>
                                  handleMenuClick(e, 'editHipotese')
                                }
                              >
                                {hipotese.sintoma}
                              </Item>
                            ))}
                          </Menu>
                        </div>
                      </Form.Group>
                      <Form.Group size="sm" controlId="editConduta">
                        <Form.Label className="d-flex justify-content-between">
                          <strong>Conduta</strong>
                          <OverlayTrigger overlay={<Tooltip>Conduta</Tooltip>}>
                            <span className="d-inline-block">
                              <Button
                                size="sm"
                                onClick={e => handleMenu(e, 'idConduta')}
                              >
                                <FaBars style={{ width: 18, height: 18 }} />
                              </Button>
                            </span>
                          </OverlayTrigger>
                        </Form.Label>
                        <div>
                          <p>
                            <Form.Control
                              disabled={inputDisabled}
                              as="textarea"
                              rows={
                                fieldValues.conduta?.split('\n').length + 1 || 3
                              }
                              name="conduta"
                              className="textAreaDestaque"
                              value={fieldValues.conduta || ''}
                              onBlur={() => handleGravarProntuarioParcial()}
                              onChange={handleChange}
                            />
                          </p>
                          <Menu className={styles.styleMenu} id={'idConduta'}>
                            {condutasSorted.map(conduta => (
                              <Item
                                key={conduta.sintoma}
                                id={conduta.sintoma}
                                onClick={e => handleMenuClick(e, 'editConduta')}
                              >
                                {conduta.sintoma}
                              </Item>
                            ))}
                          </Menu>
                        </div>
                      </Form.Group>
                      <Form.Group size="sm" controlId="editobs">
                        <Form.Label className="d-flex justify-content-between">
                          <strong>Observações</strong>
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          disabled={inputDisabled}
                          rows={fieldValues.obs?.split('\n').length + 1 || 2}
                          name="obs"
                          value={
                            isFuncionario
                              ? '********** ACESSO RESTRITO **********'
                              : fieldValues.obs || ''
                          }
                          onBlur={() => {
                            if (!isFuncionario) {
                              handleGravarProntuarioParcial();
                            }
                          }}
                          onChange={isFuncionario ? undefined : handleChange}
                        />
                      </Form.Group>
                    </Form.Row>
                    <Form.Row>
                      <Form.Group as={Col} sm={3} controlId="cid1">
                        <strong>CID1</strong>
                        <Form.Control
                          as="select"
                          name="cid"
                          disabled={inputDisabled}
                          aria-label="Selecione o CID"
                          value={fieldValues.cid3 || ''}
                          onBlur={() => handleGravarProntuarioParcial()}
                          onChange={e => {
                            const selected = cidValueLabelSorted.find(
                              opt =>
                                String(opt.value) === String(e.target.value)
                            );
                            if (selected) {
                              setFieldValues({
                                ...fieldValues,
                                cid: selected.label.split(' - ')[0],
                                cid3: selected.value,
                              });
                            } else {
                              setFieldValues({
                                ...fieldValues,
                                cid: '',
                                cid3: '',
                              });
                            }
                          }}
                        >
                          <option value="" disabled>
                            {fieldValues.cid || 'Selecione o CID'}
                          </option>
                          {cidValueLabelSorted.map(opt => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                      <Form.Group as={Col} controlId="cid2">
                        <strong>CID2</strong>
                        <Form.Control
                          disabled={inputDisabled}
                          name="cid2"
                          maxLength={150}
                          value={fieldValues.cid2 || ''}
                          onBlur={() => handleGravarProntuarioParcial()}
                          onChange={handleChange}
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="cid3">
                        <strong>INDICAÇÃO</strong>
                        <Form.Control
                          disabled={inputDisabled}
                          name="cid3"
                          maxLength={150}
                          value={fieldValues.cid3 || ''}
                          onBlur={() => handleGravarProntuarioParcial()}
                          onChange={handleChange}
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="peso">
                        <strong>PESO</strong>
                        <Form.Control
                          disabled={inputDisabled}
                          type="number"
                          name="peso"
                          value={fieldValues.peso || ''}
                          onBlur={() => handleGravarProntuarioParcial()}
                          onChange={handleChange}
                        />{' '}
                      </Form.Group>
                    </Form.Row>
                    <Alert show={showGravaParcial} variant="warning">
                      <Alert.Heading>
                        Confirma a Gravação PARCIAL da Consulta?
                      </Alert.Heading>
                      <Button
                        onClick={e => handleGravarProntuario(e)}
                        variant="warning"
                        disabled={isSavingProntuario}
                      >
                        {isSavingProntuario ? (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />{' '}
                            Gravando...
                          </>
                        ) : (
                          'Confirmar'
                        )}
                      </Button>
                    </Alert>
                    <Alert show={showGravaTotal} variant="success">
                      <Alert.Heading>
                        Confirma a Gravação DEFINITIVA da Consulta?
                      </Alert.Heading>
                      <Button
                        onClick={e => handleGravarProntuario(e)}
                        variant="success"
                        disabled={isSavingProntuario}
                      >
                        {isSavingProntuario ? (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />{' '}
                            Gravando...
                          </>
                        ) : (
                          'Confirmar'
                        )}
                      </Button>
                    </Alert>
                    <Card.Footer className="text-muted text-center">
                      <Button
                        variant="warning"
                        disabled={fieldValues.gravado.trim() === 'SIM'}
                        onClick={() => {
                          setFieldValues({ ...fieldValues, gravado: 'PAR' });
                          setShowConsulta(false);
                          setShowGravaParcial(true);
                          setShowGravaTotal(false);
                          setInputDisabled(false);
                        }}
                      >
                        Gravar Parcial
                      </Button>{' '}
                      <Button
                        variant="success"
                        disabled={fieldValues.gravado.trim() === 'SIM'}
                        onClick={() => {
                          setFieldValues({ ...fieldValues, gravado: 'SIM' });
                          setShowConsulta(false);
                          setShowGravaParcial(false);
                          setShowGravaTotal(true);
                          setInputDisabled(true);
                        }}
                      >
                        Gravar Definitivo
                      </Button>{' '}
                      <Button
                        variant="secondary"
                        disabled={isFuncionario}
                        onClick={() => {
                          generateProntuarioPDF(
                            { ...fieldValues, atual },
                            'imprimirNormal'
                          );
                        }}
                      >
                        Imprimir
                      </Button>{' '}
                      <Button
                        variant="secondary"
                        disabled={isFuncionario}
                        onClick={() => {
                          generateProntuarioPDF(
                            { ...fieldValues, atual },
                            'imprimirTimbrado'
                          );
                        }}
                      >
                        Timbrado
                      </Button>{' '}
                      <Button
                        variant="info"
                        disabled={!fieldValues.codconsulta}
                        onClick={() =>
                          handleVerArquivos(fieldValues.codconsulta)
                        }
                        aria-label="Ver arquivos da consulta"
                      >
                        Ver arquivos
                      </Button>{' '}
                      <Button
                        variant="info"
                        disabled={!fieldValues.codconsulta}
                        onClick={() => setShowUploadArquivos(true)}
                        aria-label="Anexar arquivos da consulta"
                      >
                        Anexar
                      </Button>{' '}
                      <Button
                        disabled={isFuncionario}
                        onClick={() => history.push('/agenda')}
                      >
                        Agenda
                      </Button>
                    </Card.Footer>
                  </Form>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Tab>
        <Tab
          eventKey="atv"
          title="Atividades"
          onEnter={() => handleAtividades(prontuario.atual)}
        >
          {/* CADA TAB DEVE SER UM COMPONENTE */}
          <Card>
            <Card.Header className="text-center font-weight-bold">
              ATIVIDADES DE {prontuario?.atual?.NOMEPAC}
            </Card.Header>
            <Card.Body>
              {localLoadingAtividades ? (
                <div className="text-center">
                  <Spinner animation="border" role="status" />
                </div>
              ) : (
                <Table
                  responsive="sm"
                  striped
                  bordered
                  hover
                  size="sm"
                  variant="success"
                >
                  <thead>
                    <tr>
                      <th>Procedimento</th>
                      <th>Realizou</th>
                      <th>Convênio</th>
                      <th>Data</th>
                      <th>Laudo</th>
                      <th>Guia</th>
                      <th>Laudado</th>
                      <th>Arquivos</th>
                    </tr>
                  </thead>
                  <tbody>
                    {atividades.map(a => (
                      <tr key={a.CODFATURA}>
                        {a.CODPROCEDI === 1 ||
                          a.CODPROCEDI === 58 ||
                          a.CODPROCEDI === 800 ? (
                          <td>{a.DESCPROCEDI}</td>
                        ) : a.CODPROCEDI === 13 ? (
                          <td>
                            <Button
                              onClick={() => handleStress(a)}
                              size="sm"
                              variant="link"
                            >
                              {a.DESCPROCEDI}
                            </Button>
                          </td>
                        ) : a.CODPROCEDI === 14 || a.CODPROCEDI === 15 ? (
                          <td>
                            <Button
                              onClick={() => history.push(`/report-carotida/${a.CODLAUDO}`)}
                              size="sm"
                              variant="link"
                            >
                              {a.DESCPROCEDI}
                            </Button>
                          </td>
                        ) : a.CODPROCEDI === 17 ? (
                          <td>{a.DESCPROCEDI}</td>
                        ) : a.CODPROCEDI === 3 ? (
                          <td>
                            <Button
                              onClick={() => handleEcg(a)}
                              size="sm"
                              variant="link"
                            >
                              {a.DESCPROCEDI}
                            </Button>
                          </td>
                        ) : a.CODPROCEDI === 4 ? (
                          <td>
                            <Button
                              onClick={() =>
                                history.push(`/reportErgo/${a.CODLAUDO}`)
                              }
                              size="sm"
                              variant="link"
                            >
                              {a.DESCPROCEDI}
                            </Button>
                          </td>
                        ) : a.CODPROCEDI === 12 ? (
                          <td>
                            <Button
                              onClick={() =>
                                history.push(`/report-trans/${a.CODLAUDO}`)
                              }
                              size="sm"
                              variant="link"
                            >
                              {a.DESCPROCEDI}
                            </Button>
                          </td>
                        ) : a.CODPROCEDI === 11 ||
                          a.CODPROCEDI === 712 ||
                          a.CODPROCEDI === 713 ||
                          a.CODPROCEDI === 714 ? (
                          <td>
                            <Button
                              onClick={() => handleEco(a)}
                              size="sm"
                              variant="link"
                            >
                              {a.DESCPROCEDI}
                            </Button>
                          </td>
                        ) : a.CODPROCEDI === 7 ? (
                          <td>
                            <Button
                              size="sm"
                              variant="link"
                              onClick={() =>
                                history.push(`/reportMapa/${a.CODLAUDO}`)
                              }
                            >
                              {a.DESCPROCEDI}
                            </Button>
                          </td>
                        ) : a.CODPROCEDI === 6 ? (
                          <td>
                            <Button
                              onClick={() =>
                                history.push(`/reportHolter/${a.CODLAUDO}`)
                              }
                              size="sm"
                              variant="link"
                            >
                              {a.DESCPROCEDI}
                            </Button>
                          </td>
                        ) : (
                          <td>{a.DESCPROCEDI}</td>
                        )}
                        <td>{a.CODREALIZOU}</td>
                        <td>{a.SIGLACONV}</td>
                        <td>{a.dataFormatada}</td>
                        <td>{a.CODLAUDO}</td>
                        <td>{a.GUIA}</td>
                        <td>{a.GUIA1}</td>
                        <td>
                          {PROCEDIMENTOS_CONSULTA.includes(a.CODPROCEDI) &&
                            a.CODLAUDO ? (
                            <Button
                              size="sm"
                              variant="link"
                              className="p-0 align-baseline"
                              onClick={() => handleVerArquivos(a.CODLAUDO)}
                              aria-label={`Ver arquivos do laudo ${a.CODLAUDO}`}
                            >
                              Ver
                            </Button>
                          ) : null}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Tab>
        <Tab eventKey="pac" title="Paciente">
          <PacienteInfo codPac={atual?.CODPAC} />
        </Tab>
      </Tabs>

      <Modal show={showReceita} size="xl">
        <Modal.Header className="font-weight-bold">
          RECEITUÁRIO MÉDICO
        </Modal.Header>
        <Modal.Body>
          <ReceituarioMedico
            closeModal={() => {
              setAssinaturaDigital(false);
              setShowReceita(false);
            }}
            codPaciente={atual?.CODPAC}
            codConsulta={atual?.CODCONSULTA}
            renderTreeMedicamento={renderTreeMedicamento}
            assinaturaDigital={assinaturaDigital}
            setAssinaturaDigital={setAssinaturaDigital}
          />
        </Modal.Body>
      </Modal>

      <AtestadoMedico
        show={showAtestado}
        atual={atual}
        medico={medico}
        funcionario={funcionario}
        onHide={handleFecharAtestado}
      />

      {showRequisicao && (
        <RequisicaoMedica
          show
          atual={atual}
          medico={medico}
          funcionario={funcionario}
          onHide={handleFecharRequisicao}
        />
      )}

      <ArquivosProntuarioModal
        key={codArquivos || 'sem-laudo'}
        codLaudo={codArquivos}
        onHide={handleFecharArquivos}
      />

      <FileUploadModal
        show={showUploadArquivos}
        onHide={() => setShowUploadArquivos(false)}
        atividade={{
          CODLAUDO: fieldValues.codconsulta,
          CODPROCEDI: codProcediArquivo,
        }}
        accept={ACCEPT_ARQUIVO_PRONTUARIO}
      />

      <ExamesLaboratoriaisModal
        show={examesLaboratoriais.showExamesLab}
        onHide={() => examesLaboratoriais.setShowExamesLab(false)}
        atual={atual}
        isLoadingExames={examesLaboratoriais.isLoadingExames}
        showGraficoExamesLab={examesLaboratoriais.showGraficoExamesLab}
        setShowGraficoExamesLab={examesLaboratoriais.setShowGraficoExamesLab}
        showTabelaExamesLab={examesLaboratoriais.showTabelaExamesLab}
        setShowTabelaExamesLab={examesLaboratoriais.setShowTabelaExamesLab}
        showTodosExamesLab={examesLaboratoriais.showTodosExamesLab}
        setShowTodosExamesLab={examesLaboratoriais.setShowTodosExamesLab}
        laboratoriais={examesLaboratoriais.laboratoriais}
        setLaboratoriais={examesLaboratoriais.setLaboratoriais}
        viewexames={examesLaboratoriais.viewexames}
        tabelaexames={examesLaboratoriais.tabelaexames}
        chartExames={examesLaboratoriais.chartExames}
        tableExames={examesLaboratoriais.tableExames}
        uniqueExames={examesLaboratoriais.uniqueExames}
        toggleValor={examesLaboratoriais.toggleValor}
        toggleResultado={examesLaboratoriais.toggleResultado}
        handleExibirResultadoExames={
          examesLaboratoriais.handleExibirResultadoExames
        }
        handleExibirTabelaExames={examesLaboratoriais.handleExibirTabelaExames}
        handleExcluirZerados={examesLaboratoriais.handleExcluirZerados}
      />
    </>
  );
}
